import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { message } from '@/components/Message';
import { BarcodeOutlined } from '@ant-design/icons';
import { GoodsSnScanner } from '../QRScanner';
import SpToGoods from '../StandardProductCom/SpToGoods';
import { requestHasSkuSn, SKUWrapper } from '@/models/sku';
import { IS_POS } from '@/utils/env';
import Modal from '../Modal';
import { SpToGoodsFormProps } from './SpToGoodsForm';
import PosButton from '../PosButton';

type Props = {
  open: boolean;
  onRequestClose: () => void;
  barcode?: string;
  onSuccess?: (skuWrapper: SKUWrapper) => void;
  // 连续添加商品模式 / 单个商品模式
  singleMode?: boolean;
  fillSpecificationInfo?: SpToGoodsFormProps['fillSpecificationInfo'];
  showSuccessTip?: boolean;
};

const SpToGoodsModal: React.FC<Props> = ({
  open,
  onRequestClose,
  barcode: initBarcode,
  onSuccess = () => {},
  singleMode = false,
  fillSpecificationInfo = true,
  showSuccessTip = true,
}: Props) => {
  const [barcode, setBarcode] = useState<string>();
  const [input, setInput] = useState<string>();
  const [showTip, setShowTip] = useState(true);
  const [valid, setValid] = useState(IS_POS);
  const reset = () => {
    setBarcode(undefined);
    setInput('');
    setShowTip(true);
    setValid(IS_POS || singleMode);
  };

  useEffect(() => {
    setBarcode(initBarcode);
  }, [initBarcode]);

  const onClose = () => {
    onRequestClose();
    reset();
  };

  useEffect(() => {
    if (barcode) {
      if (!IS_POS && !singleMode) {
        requestHasSkuSn(barcode).then(has => {
          setValid(!has);
          if (has) {
            message.error('该商品已经在商品库中');
            reset();
          }
        });
      } else {
        setValid(true);
      }
    }
  }, [barcode]);

  return (
    <Modal
      destroyOnHidden
      onCancel={onClose}
      footer={
        <>
          <PosButton onClick={onClose}>关闭</PosButton>
        </>
      }
      open={open}
      title={
        <>
          <BarcodeOutlined /> 标准化商品管理
        </>
      }>
      {showTip && (
        <>
          <GoodsSnScanner
            onChange={v => {
              setBarcode(v);
              setInput(v);
            }}
          />
          <Input
            style={{ display: 'block', width: 200, margin: '0 auto 10px', textAlign: 'center' }}
            value={input}
            onChange={({ target: { value } }) => {
              setInput(value);
            }}
            onPressEnter={() => {
              setBarcode(input);
            }}
          />
        </>
      )}
      {valid && (
        <SpToGoods
          fillSpecificationInfo={fillSpecificationInfo}
          barcode={barcode}
          onSuccess={v => {
            onSuccess(v);
            if (showSuccessTip) {
              message.success('添加成功! 您可以继续扫码添加。');
            }
            reset();
          }}
          onFind={() => {
            setShowTip(false);
          }}
          onCancel={() => {
            if (IS_POS || singleMode) {
              onRequestClose();
            } else {
              reset();
            }
          }}
        />
      )}
    </Modal>
  );
};

export default SpToGoodsModal;
